import { Factory } from 'fishery';
import { Invoice } from '@trukt/types/Invoice';
import { userFactory } from './userFactory';
import { accountFactory } from './accountFactory';
import { lineFactory } from './lineFactory';

export const invoiceFactory = Factory.define<Invoice>(({ sequence }) => ({
  dateUpdated: '2024-03-24T12:30:00Z',
  guid: sequence.toString(),
  type: 'INVOICE',
  status: 'OPEN',
  paymentHeld: false,
  paymentStatus: 'RELEASED',
  datePaymentReleased: '2024-03-21T10:15:00Z',
  referenceNumber: '12345678',
  total: '1200.50',
  dateTransaction: '2024-03-20T12:30:00Z',
  dateCreated: '2024-03-19T12:30:00Z',
  consignee: accountFactory.build({ name: 'Joe' }),
  paymentReleasedBy: userFactory.build({
    guid: 'user-1',
    name: 'payment user',
  }),
  lines: lineFactory.buildList(2),
  job: { guid: 'job-1', status: 'new', number: '123A' },
  order: { guid: 'order-1', status: 'scheduled', number: '123' },
  client: { guid: 'client-1', name: 'Bob' },
  clientContact: { guid: 'contact-1', name: 'Will' },
  paymentMethodId: '1',
  paymentTermsId: '1',
  paymentConfig: {
    id: '1',
    fee: '3.00',
    label: 'Net 30',
  },
}));
